/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DiscountAdminDto } from '../models/DiscountAdminDto';
import type { DiscountType } from '../models/DiscountType';
import type { GetDiscountCategoriesAdminResponse } from '../models/GetDiscountCategoriesAdminResponse';
import type { GetDiscountGroupsAdminResponse } from '../models/GetDiscountGroupsAdminResponse';
import type { GetDiscountUsersAdminResponse } from '../models/GetDiscountUsersAdminResponse';
import type { Pagination1OfDiscountAdminListedDto } from '../models/Pagination1OfDiscountAdminListedDto';
import type { Pagination1OfItemAdminListedDto } from '../models/Pagination1OfItemAdminListedDto';
import type { PostDiscountRequestAdmin } from '../models/PostDiscountRequestAdmin';
import type { PutDiscountRequestAdmin } from '../models/PutDiscountRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DiscountsService {
    /**
     * **Required Policy:** `ManageDiscounts`
     * @returns DiscountAdminDto OK
     * @throws ApiError
     */
    public static postDiscountAdmin({
        requestBody,
    }: {
        requestBody?: PostDiscountRequestAdmin,
    }): CancelablePromise<DiscountAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/discounts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDiscounts`
     * @returns Pagination1OfDiscountAdminListedDto OK
     * @throws ApiError
     */
    public static getDiscountsAdmin({
        searchWord,
        type,
        minValue,
        maxValue,
        maxDiscountAllowed,
        fromStartDate,
        toStartDate,
        fromEndDate,
        toEndDate,
        firstPurchase,
        branchId,
        categoryId,
        userId,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        searchWord?: string,
        type?: DiscountType,
        minValue?: number,
        maxValue?: number,
        maxDiscountAllowed?: number,
        fromStartDate?: string,
        toStartDate?: string,
        fromEndDate?: string,
        toEndDate?: string,
        firstPurchase?: boolean,
        branchId?: number,
        categoryId?: number,
        userId?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfDiscountAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/discounts',
            query: {
                'searchWord': searchWord,
                'type': type,
                'minValue': minValue,
                'maxValue': maxValue,
                'maxDiscountAllowed': maxDiscountAllowed,
                'fromStartDate': fromStartDate,
                'toStartDate': toStartDate,
                'fromEndDate': fromEndDate,
                'toEndDate': toEndDate,
                'firstPurchase': firstPurchase,
                'branchId': branchId,
                'categoryId': categoryId,
                'userId': userId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDiscountDetails`
     * @returns DiscountAdminDto OK
     * @throws ApiError
     */
    public static getDiscountAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<DiscountAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/discounts/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDiscounts`
     * @returns DiscountAdminDto OK
     * @throws ApiError
     */
    public static putDiscountAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutDiscountRequestAdmin,
    }): CancelablePromise<DiscountAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/discounts/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteDiscounts`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteDiscountAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/discounts/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDiscountDetails`
     * @returns GetDiscountUsersAdminResponse OK
     * @throws ApiError
     */
    public static getDiscountUsersAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetDiscountUsersAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/discounts/{id}/users',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDiscountDetails`
     * @returns GetDiscountGroupsAdminResponse OK
     * @throws ApiError
     */
    public static getDiscountGroupsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetDiscountGroupsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/discounts/{id}/groups',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDiscountDetails`
     * @returns GetDiscountCategoriesAdminResponse OK
     * @throws ApiError
     */
    public static getDiscountCategoriesAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetDiscountCategoriesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/discounts/{id}/categories',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDiscountDetails`
     * @returns Pagination1OfItemAdminListedDto OK
     * @throws ApiError
     */
    public static getDiscountItemsAdmin({
        id,
        searchWord,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id: number,
        searchWord?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfItemAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/discounts/{id}/items',
            path: {
                'id': id,
            },
            query: {
                'searchWord': searchWord,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @deprecated
     * **Required Policy:** `DeleteDiscounts`
     * @returns any OK
     * @throws ApiError
     */
    public static postBranchLabelsForDiscountAdmin(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/discounts/branch-labels',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
